/**
 * A callout (lexicalNodes/CalloutNode.js) in the PDF export: a bordered,
 * filled one-cell table — pdfmake's only box that flows text — with the
 * kind's label in its colour first, so the kind survives a black-and-white
 * print too (not colour alone).
 */
import i18n from '../../i18n';

// Labels are i18n keys, resolved at export time so the PDF follows the UI language.
const KIND = {
  info: { labelKey: 'docEditor.callout.pdfNote', color: '#6d5dd3' },
  warning: { labelKey: 'docEditor.callout.pdfWarning', color: '#b45309' },
  success: { labelKey: 'docEditor.callout.pdfTip', color: '#15803d' },
};

const CALLOUT_LAYOUT = {
  hLineWidth: () => 0.7,
  vLineWidth: () => 0.7,
  hLineColor: () => '#e4e4e7',
  vLineColor: () => '#e4e4e7',
  fillColor: () => '#fafafa',
  paddingLeft: () => 10,
  paddingRight: () => 10,
  paddingTop: () => 8,
  paddingBottom: () => 8,
};

/** @param {Element} node  the saved `<div data-callout>`; @param {Array} runs  its inline runs */
export function calloutPdfBlock(node, runs) {
  const kind = KIND[node.getAttribute('data-callout')] || KIND.info;
  return [{
    table: {
      widths: ['*'],
      body: [[{ text: [{ text: `${i18n.t(kind.labelKey)}  `, bold: true, color: kind.color }, ...runs] }]],
    },
    layout: CALLOUT_LAYOUT,
    margin: [0, 6, 0, 12],
  }];
}
